import CompanyAPI from 'dashboard/api/companies';
import ContactAPI from 'dashboard/api/contacts';

const readContact = async id => {
  const { data } = await ContactAPI.show(id);
  return data.payload;
};

export const updateCompanyMembership = async ({
  companyId,
  contactId,
  remove = false,
}) => {
  const matches = contact =>
    remove
      ? Number(contact.company_id) !== Number(companyId)
      : Number(contact.company_id) === Number(companyId);
  const current = await readContact(contactId);
  if (matches(current)) return current;

  try {
    if (remove) {
      await CompanyAPI.removeContact(companyId, contactId);
      return { ...current, company_id: null };
    }
    const { data } = await CompanyAPI.createContact(companyId, {
      contact_id: contactId,
    });
    return data.payload;
  } catch (error) {
    const confirmed = await readContact(contactId);
    if (matches(confirmed)) return confirmed;
    throw error;
  }
};
